import { useFormContext } from 'react-hook-form';
import { LwFormNumberInput } from 'redesign';
import { PreferredWorkerFormContext } from '../preferred-worker.types';
type Props = {
  index: number;
  disabled?: boolean;
};
export const ConditionTimeInput = ({ index, disabled }: Props) => {
  const { control } = useFormContext<PreferredWorkerFormContext>();
  return (
    <LwFormNumberInput
      name={`visibilityRules.${index}.durationCondition`}
      label={`Reactietermijn (uren)`}
      control={control}
      disabled={disabled}
      rules={{
        required: 'De tijd moet een geheel getal in uren zijn',
      }}
      step={1}
      min={1}
    />
  );
};
